import React from "react";
import {
  checkboxLabelClass,
  checkboxElement,
  checkboxWrapper,
} from "./checkbox.module.css";

/**
 * type is for the input type itself
 * inputType is to choose between "textarea" or 'input'
 * error is the error state of the textField
 * icon should take icons in a html elements
 * errorText holds the error message if you want to show one
 *
 */
const Checkbox = ({
  onClick = () => {},
  type = "",
  placeholder = "",
  value = "",
  className = "",
  onChange = () => {},
  disabled = false,
  name = "",
  required = false,
  error = false,
  icon = "",
  radioText,
  checked,
  checkboxLabel,
  ...restProps
}) => {
  return (
    <div className={checkboxWrapper}>
       {" "}
      <input
        className={`${className} ${checkboxElement}`}
        type={type}
        value={value}
        placeholder={placeholder}
        onClick={onClick}
        disabled={disabled}
        onChange={onChange}
        name={name}
        required={required}
        checked={checked}
        {...restProps}
      />
       {" "}
      <label className={checkboxLabelClass} htmlFor={restProps?.id}>
        {checkboxLabel}
      </label>
    </div>
  );
};

export { Checkbox };
